/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_State_UpstreamInputs */

const vi_vehicle_gps_state_upstream = /** @type {(inputs: Vehicle_Gps_State_UpstreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VnetGPS đang lỗi hoặc không phản hồi.`)
};

/**

* @param {Vehicle_Gps_State_UpstreamInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_state_upstream = /** @type {((inputs?: Vehicle_Gps_State_UpstreamInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_State_UpstreamInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_state_upstream(inputs)
});